import { useMemo } from "react";
import cx from "classnames";
import { RiskKeys } from "@/config";
import type { AmlHistoryItemData } from "@/store";
import { SvgIcon } from "@/components";

import styles from "./SanctionNote.module.sass";

interface SanctionNoteProps {
  item: AmlHistoryItemData;
  isLoading?: boolean;
}

const SanctionNote = (props: SanctionNoteProps) => {
  const { item, isLoading } = props;

  const sanctioned = useMemo(() => {
    return item.signalTags.includes(RiskKeys.SANCTIONS);
  }, [item.signalTags]);

  const sanctionNote = useMemo(() => {
    if (sanctioned) {
      return "Keep in mind! Some connections trace back to sanctioned entities.";
    }
    return "Not found any sanctions connections";
  }, [sanctioned]);

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={cx(
        styles.box,
        styles[`box--${sanctioned ? "danger" : "trusted"}`],
      )}
    >
      <div className={styles.title}>Sanctions screening</div>
      <div className={styles.note}>
        <SvgIcon
          name={`shield-${sanctioned ? "red" : "green"}`}
          className={styles.icon}
        />{" "}
        {sanctionNote}
      </div>
    </div>
  );
};

export default SanctionNote;
